import { hasPermission, PERMISSIONS } from "./permissions";

export const canHolidaysTab = () =>
  hasPermission(PERMISSIONS.HRMS_HOLIDAY_VIEW) ||
  hasPermission(PERMISSIONS.HRMS_HOLIDAY_ADD) ||
  hasPermission(PERMISSIONS.HRMS_HOLIDAY_EDIT);

export const canProfilesTab = () =>
  hasPermission(PERMISSIONS.HRMS_PROFILE_VIEW) ||
  hasPermission(PERMISSIONS.HRMS_PAYROLL_ADD) ||
  hasPermission(PERMISSIONS.HRMS_PROFILE_ADD) ||
  hasPermission(PERMISSIONS.HRMS_PROFILE_EDIT);

export const canIncentivesTab = () =>
  hasPermission(PERMISSIONS.HRMS_INCENTIVE_VIEW) ||
  hasPermission(PERMISSIONS.HRMS_INCENTIVE_ADD) ||
  hasPermission(PERMISSIONS.HRMS_INCENTIVE_EDIT) ||
  hasPermission(PERMISSIONS.HRMS_INCENTIVE_APPROVE);

export const canOvertimeTab = () =>
  hasPermission(PERMISSIONS.HRMS_OVERTIME_VIEW) ||
  hasPermission(PERMISSIONS.HRMS_OVERTIME_ADD) ||
  hasPermission(PERMISSIONS.HRMS_OVERTIME_EDIT) ||
  hasPermission(PERMISSIONS.HRMS_OVERTIME_APPROVE);

export const canAdvancesTab = () =>
  hasPermission(PERMISSIONS.HRMS_ADVANCE_VIEW) ||
  hasPermission(PERMISSIONS.HRMS_ADVANCE_ADD) ||
  hasPermission(PERMISSIONS.HRMS_ADVANCE_EDIT);

export const canPayrollTab = () =>
  hasPermission(PERMISSIONS.HRMS_PAYROLL_RUN) ||
  hasPermission(PERMISSIONS.HRMS_PAYROLL_VIEW) ||
  hasPermission(PERMISSIONS.HRMS_PAYROLL_LOCK);

export const canAttendanceTab = () =>
  hasPermission(PERMISSIONS.HRMS_ATTENDANCE_VIEW) ||
  hasPermission(PERMISSIONS.HRMS_ATTENDANCE_ADD);
